import { Users, CalendarDays, MapPin, Globe2, type LucideIcon } from "lucide-react";
import { stats } from "./StatFlipCards";
import Img from "./Img";

/** "By the numbers" beside Our Purpose as four colored cards in the palette (marketing mockup,
 *  Nov 2026): red Total Builders with a group photo, gold Years, green Locations with a mountain
 *  photo, navy Countries. The cards are not links. Photos sit under a strong color wash so the
 *  text keeps AA contrast. On desktop the stack stretches to the copy beside it. */
const look: { bg: string; wash: string; text: string; rule: string; Icon: LucideIcon; photo?: string; pos?: string; tilt: string }[] = [
  { bg: "bg-[#b94737]", wash: "bg-[#8f3426]/80", text: "text-white", rule: "bg-[#e9bab4]", Icon: Users, photo: "/images/audience/builders-flex.jpg", tilt: "lg:-rotate-1" }, // Builders flexing at a worksite (marketing, Nov 2026)
  { bg: "bg-[#8a6e2f]", wash: "bg-[#735b25]/80", text: "text-white", rule: "bg-[#f0e6aa]", Icon: CalendarDays, photo: "/images/audience/years-bus.jpg", tilt: "lg:rotate-1" }, // early-years bus photo (marketing, Nov 2026)
  { bg: "bg-[#2e3c18]", wash: "bg-[#2e3c18]/80", text: "text-[#efe8de]", rule: "bg-[#cccb95]", Icon: MapPin, photo: "/images/audience/overlook.jpg", tilt: "lg:rotate-1" },
  { bg: "bg-[#193f49]", wash: "bg-[#193f49]/80", text: "text-[#efe8de]", rule: "bg-[#a9c0be]", Icon: Globe2, photo: "/images/audience/countries-beach.jpg", pos: "object-[center_70%]", tilt: "lg:-rotate-1" }, // Builders walking to the beach (marketing, Nov 2026)
];

const StatList = () => (
  <ul className="grid w-full grid-cols-2 gap-3 md:gap-4 lg:h-full lg:grid-cols-[1.5fr_1fr] lg:grid-rows-2">
    {stats.map((s, i) => {
      const l = look[i];
      return (
        <li
          key={s.label}
          className={`relative flex flex-col justify-end overflow-hidden rounded-2xl p-5 shadow-[0_12px_28px_rgba(56,54,50,0.18)] md:p-6 ${l.bg} ${l.text} ${l.tilt} ${
            i === 0 || i === 3 ? "col-span-2 lg:col-span-1" : ""
          }`}
        >
          {l.photo && (
            <>
              <Img src={l.photo} alt="" sizes="(min-width: 1024px) 400px, 100vw" loading="lazy" className={`absolute inset-0 h-full w-full object-cover ${l.pos ?? ""}`} />
              <div className={`absolute inset-0 ${l.wash}`} />
            </>
          )}
          {!l.photo && (
            <l.Icon aria-hidden="true" strokeWidth={1} className="absolute -right-6 -top-6 h-36 w-36 opacity-15 md:h-44 md:w-44" />
          )}
          {/* label first for screen readers, shown under the number */}
          <div className="relative order-last mt-3">
            <span className="btn-caps block text-xs tracking-[0.22em] md:text-sm">{s.label}</span>
            <span className={`mt-2 block h-0.5 w-10 ${l.rule}`} />
          </div>
          <div className="relative">
            <l.Icon aria-hidden="true" strokeWidth={1.75} className="mb-3 h-8 w-8 md:h-10 md:w-10" />
            <span className={`font-heading block leading-[0.85] ${i === 0 ? "text-6xl sm:text-7xl lg:text-6xl xl:text-7xl" : "text-5xl sm:text-6xl lg:text-6xl xl:text-7xl"}`}>
              {s.value}
            </span>
          </div>
        </li>
      );
    })}
  </ul>
);

export default StatList;
